import { css } from '@emotion/react';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { TooltipComponent } from '~/_shared/baseComponents/tooltip/tooltip.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';
import type { Place } from '~/places/places.types';
import { getPlacesToolCircleColors } from './placesTool.helpers';
import {
  placeCircleStyle, placeDistanceLabelStyle,
} from './placesTool.styles';

const containerStyle = (theme: Theme) => css({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  border: `1px solid ${theme.accordionColors.borderColor}`,
  padding: '12px 10px 12px 13px',
  boxSizing: 'border-box',
});

const leftStyle = css({
  width: 37,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 6,
});

const centerStyle = (theme: Theme) => css({
  flexGrow: 1,
  flexBasis: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  color: theme.textColors.primary,
});

const placeTitleStyle = css({
  fontSize: 16,
});

const placeMoreInfoStyle = css({
  fontSize: 12,
});

const rightStyle = css({
  width: 20,
  flexShrink: 0,
});

const trashIconStyle = (theme: Theme) => css({
  color: theme.textColors.danger,
  '&:hover': {
    color: theme.textColors.dangerOnHover,
  },
});

export const PlacesListingPlaceDetailsComponent = ({
  color,
  place,
  index,
  onHover,
  onHoverStopped,
  onRemove,
}: {
  color: string;
  place: Place & Readonly<{ distance?: string }>;
  index: number;
  onHover: () => void;
  onHoverStopped: () => void;
  onRemove?: () => void;
}) => {
  const [t] = useTranslation();

  const placesToolCircleColors = getPlacesToolCircleColors(color);

  return (
    <div
      onMouseEnter={onHover}
      onMouseLeave={onHoverStopped}
      css={containerStyle}
    >
      <div css={leftStyle}>
        {/*<div> // this is being added in phase 2
          <CheckboxComponent
            checkedSetter={noop}
            isChecked={false}
          />
        </div>
        */}
        <div
          css={placeCircleStyle(placesToolCircleColors)}
        >
          {index + 1}
        </div>
        <div css={placeDistanceLabelStyle(placesToolCircleColors)}>
          {place.distance}
        </div>
      </div>
      <div css={centerStyle}>
        <div css={placeTitleStyle}>{place.name}</div>
        <div css={placeMoreInfoStyle}>{place.address}</div>
      </div>
      <div css={rightStyle}>
        <TooltipComponent tooltipContent={t('placesTool.place.removeFromResults')}>
          <FontAwesomeIcon
            icon={faTrash}
            css={trashIconStyle}
            onClick={onRemove}
            title={t('placesTool.place.removeFromResults')}
          />
        </TooltipComponent>
      </div>
    </div>
  );
};
